import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconQuiz$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconQuiz extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4d51dc254e3a222f6e999a8c17d4c1ba620178ce', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fdaaee63b285df3d42e48345a4cb40d081dff241', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '71ccdb622b5b6f8087b5bccbe432ed41c2064d3c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 2.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H15v3.44a.3.3 0 0 1-.47.25L9 16H3.5a.5.5 0 0 1-.5-.5zm14.5 12v-11h-13v11h4.8a.54.54 0 0 1 .28.08l3.92 2.62V15a.5.5 0 0 1 .5-.5zM12 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.27 5.55h2a2 2 0 0 1 2.3 2.08c0 .81-.25 1.27-1.58 2.27a.57.57 0 0 1-.31.1h-1.16a.25.25 0 0 1-.25-.25v-.16a.24.24 0 0 1 .1-.19l.412-.338c.9-.736 1.108-.907 1.108-1.232A.78.78 0 0 0 11 7H9.27a.29.29 0 0 1-.3-.3v-.85a.29.29 0 0 1 .3-.3", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-quiz", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-quiz"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-quiz":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconQuiz$1);
            }
            break;
    } });
}

const CosmosIconQuiz = CosmosIconQuiz$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconQuiz, defineCustomElement };
